<template>
  <svg
    height="0"
    width="0"
    style="display: none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <symbol id="align-bottom" viewBox="0 0 21 22" fill="none">
      <path
        d="M6.70042 10.2219L11 14.5215L15.2996 10.2219"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 2.47914L11 14.4004"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="20"
        y1="21"
        x2="1"
        y2="21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </symbol>
    <symbol id="align-center" viewBox="0 0 21 26" fill="none">
      <path
        d="M8.42025 6.13119L11 8.71094L13.5798 6.13119"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 1.48592L11 8.63867"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.42025 19.8688L11 17.2891L13.5798 19.8688"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 24.5141L11 17.3613"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="20"
        y1="13"
        x2="1"
        y2="13"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </symbol>
    <symbol id="align-top" viewBox="0 0 21 22" fill="none">
      <path
        d="M14.2996 11.7781L10 7.47852L5.70042 11.7781"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 19.5209V7.59961"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="1"
        y1="1"
        x2="20"
        y2="1"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </symbol>
    <symbol id="check" viewBox="0 0 14 11" fill="none">
      <path
        d="M4.59583 11C4.01138 11 3.45351 10.7729 3.05503 10.3945L0.637571 8.09862C-0.212524 7.29128 -0.212524 5.97936 0.637571 5.17202C1.48767 4.36468 2.86907 4.36468 3.71916 5.17202L4.59583 6.00459L10.2808 0.605505C11.1309 -0.201835 12.5123 -0.201835 13.3624 0.605505C14.2125 1.41284 14.2125 2.72477 13.3624 3.53211L6.13662 10.3945C5.71157 10.7729 5.18027 11 4.59583 11Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="chevron-down" viewBox="0 0 13 8" fill="none">
      <path
        d="M6.5 6.5L12 1"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 1L6.5 6.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="arrow-drop-down" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_2235_8172"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_2235_8172)">
        <path d="M12 15L7 10H17L12 15Z" fill="currentColor" />
      </g>
    </symbol>
    <symbol id="user-test" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.43094 16.9025C7.05587 16.2213 9.2233 16 12 16C14.771 16 16.9351 16.2204 18.5586 16.8981C20.3012 17.6255 21.3708 18.8613 21.941 20.6587C22.1528 21.3267 21.6518 22 20.9592 22H3.03459C2.34482 22 1.84679 21.3297 2.0569 20.6654C2.62537 18.8681 3.69119 17.6318 5.43094 16.9025Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="delete" viewBox="0 0 10 9" fill="none">
      <path
        d="M1 1L5 4.5L1 8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 1L5 4.5L9 8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="bucket" viewBox="0 0 11 11" fill="none">
      <path
        d="M2.58325 10.75C2.26242 10.75 1.98777 10.6358 1.75929 10.4073C1.53082 10.1788 1.41659 9.90417 1.41659 9.58333V2H0.833252V0.833333H3.74992V0.25H7.24992V0.833333H10.1666V2H9.58325V9.58333C9.58325 9.90417 9.46902 10.1788 9.24054 10.4073C9.01207 10.6358 8.73742 10.75 8.41659 10.75H2.58325ZM3.74992 8.41667H4.91659V3.16667H3.74992V8.41667ZM6.08325 8.41667H7.24992V3.16667H6.08325V8.41667Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="gallery-bold" viewBox="0 0 24 24" fill="none">
      <path
        d="M2.58005 19.0103L2.56005 19.0303C2.29005 18.4403 2.12005 17.7703 2.05005 17.0303C2.12005 17.7603 2.31005 18.4203 2.58005 19.0103Z"
        fill="currentColor"
      />
      <path
        d="M9 10.3801C10.3144 10.3801 11.38 9.31456 11.38 8.00012C11.38 6.68568 10.3144 5.62012 9 5.62012C7.68556 5.62012 6.62 6.68568 6.62 8.00012C6.62 9.31456 7.68556 10.3801 9 10.3801Z"
        fill="currentColor"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 17.28 2.19 18.23 2.56 19.03C3.42 20.93 5.26 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V13.9V7.81C22 4.17 19.83 2 16.19 2ZM20.37 12.5C19.59 11.83 18.33 11.83 17.55 12.5L13.39 16.07C12.61 16.74 11.35 16.74 10.57 16.07L10.23 15.79C9.52 15.17 8.39 15.11 7.59 15.65L3.85 18.16C3.63 17.6 3.5 16.95 3.5 16.19V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V12.61L20.37 12.5Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="gallery" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66998 18.9505L7.59998 15.6405C8.38998 15.1105 9.52998 15.1705 10.24 15.7805L10.57 16.0705C11.35 16.7405 12.61 16.7405 13.39 16.0705L17.55 12.5005C18.33 11.8305 19.59 11.8305 20.37 12.5005L22 13.9005"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="loader-oval" viewBox="0 0 38 38" stroke="currentColor">
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
          <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </symbol>
    <symbol id="login" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.6801 14.62L14.2401 12.06L11.6801 9.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 12.0601H14.17"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="logo" viewBox="0 0 30 30" fill="none">
      <path
        d="M14.3821 20.3805C12.308 20.3805 11.0723 19.3994 10.6749 17.4371C9.07273 19.3994 7.26568 20.3805 5.25371 20.3805C3.77578 20.3805 2.52761 19.9769 1.5092 19.1696C0.490798 18.3624 -0.0121951 17.2384 0.00022445 15.7977C0.00022445 11.7986 3.54602 9.37058 10.6376 8.51363V5.98003C10.6376 4.55178 10.234 3.45265 9.42669 2.68263C8.63184 1.91262 7.5327 1.52761 6.12929 1.52761C5.45863 1.52761 4.71346 1.65181 3.89377 1.9002C4.86249 2.08649 5.60767 2.47771 6.12929 3.07385C6.65091 3.68241 6.90552 4.3779 6.8931 5.16034C6.8931 5.99245 6.57019 6.70037 5.92437 7.28409C5.29097 7.86781 4.55821 8.15967 3.7261 8.15967C2.84431 8.15967 2.10534 7.88023 1.5092 7.32135C0.913064 6.75005 0.614994 6.0235 0.614994 5.14171C0.614994 3.6141 1.4409 2.37835 3.0927 1.43446C4.73209 0.502993 6.87447 0.0248392 9.51984 0C10.7245 0 11.7926 0.111776 12.7241 0.335329C13.6556 0.546462 14.4939 0.90042 15.2391 1.3972C15.9842 1.88157 16.5555 2.56464 16.953 3.44644C17.3504 4.32823 17.5491 5.3901 17.5491 6.63206V14.4937C17.5615 15.1519 17.5926 15.6549 17.6423 16.0026C17.6919 16.338 17.7975 16.6671 17.959 16.99C18.1328 17.3129 18.3936 17.5551 18.7414 17.7165C19.1016 17.878 19.5797 18.0022 20.1758 18.0891V18.2382C19.4058 18.8467 18.4744 19.3559 17.3814 19.7658C16.3009 20.1756 15.3012 20.3805 14.3821 20.3805ZM9.53847 9.42647C8.83055 9.42647 8.20336 9.81147 7.6569 10.5815C7.11044 11.3639 6.84342 12.3513 6.85584 13.5436C6.85584 14.7731 7.10423 15.6984 7.60101 16.3193C8.11022 16.9527 8.63184 17.2694 9.16588 17.2694C9.73718 17.2694 10.2278 17.1701 10.6376 16.9714V9.61276C10.1532 9.48856 9.78686 9.42647 9.53847 9.42647Z"
        fill="currentColor"
      />
      <path
        d="M30.0002 28.8971V29.0462H18.8971V28.8971C19.8037 28.3879 20.375 27.7918 20.611 27.1087C20.8594 26.4132 20.9898 25.3265 21.0022 23.8486V16.1919C21.0022 14.4904 20.847 13.323 20.5365 12.6896C20.226 12.0438 19.5491 11.4787 18.5059 10.9943V10.8453C21.027 10.6217 24.1071 10.0504 27.746 9.13137H27.8951V23.8486C27.8951 25.3141 28.0193 26.4008 28.2677 27.1087C28.516 27.8042 29.0936 28.4004 30.0002 28.8971ZM24.3182 8.59111C23.3619 8.59111 22.5546 8.25578 21.8964 7.58513C21.2382 6.90205 20.8966 6.08236 20.8718 5.12605C20.8966 4.16974 21.2382 3.36247 21.8964 2.70423C22.5546 2.03357 23.3619 1.69824 24.3182 1.69824C25.2745 1.69824 26.088 2.03357 26.7587 2.70423C27.4418 3.37489 27.7833 4.18216 27.7833 5.12605C27.7833 6.06994 27.4418 6.88342 26.7587 7.5665C26.0756 8.24958 25.2621 8.59111 24.3182 8.59111Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="logout" viewBox="0 0 24 24" fill="none">
      <path
        d="M17.4399 14.62L19.9999 12.06L17.4399 9.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.76001 12.0601H19.93"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.76 20C7.34001 20 3.76001 17 3.76001 12C3.76001 7 7.34001 4 11.76 4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="paragraph-spacing" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 22H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 2H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 6V18"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 7.72062L12 4.89062L9.17 7.72062"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 15.8906L12 18.7206L9.17 15.8906"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="plus" viewBox="0 0 15 15" fill="none">
      <line
        x1="8"
        y1="14"
        x2="8"
        y2="1"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="1"
        y1="7"
        x2="14"
        y2="7"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </symbol>

    <symbol id="arrow-right" viewBox="0 0 13 8" fill="none">
      <path
        d="M8.67993 6.12L11.2399 3.56L8.67993 1"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 3.56H11.17"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>

    <symbol id="arrows-right" viewBox="0 0 17 10" fill="none">
      <path
        d="M11.5 1.5L15.5 5L11.5 8.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.5 1.5L10.5 5L6.5 8.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.1"
        d="M1.5 1.5L5.5 5L1.5 8.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="smallcaps" viewBox="0 0 24 24" fill="none">
      <path
        d="M1.99 5.93031V4.42031C1.99 3.40031 2.82 2.57031 3.84 2.57031H16.76C17.78 2.57031 18.61 3.40031 18.61 4.42031V5.93031"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3 18.1003V3.32031"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.9 18.0996H12.48"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.68 10.3398H20.69C21.42 10.3398 22.01 10.9298 22.01 11.6598V12.4598"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.08 21.4291V10.8691"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.94 21.4297H18.22"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="text" viewBox="0 0 24 24" fill="none">
      <path
        d="M2.66998 7.1693V5.3493C2.66998 4.1993 3.59998 3.2793 4.73998 3.2793H19.26C20.41 3.2793 21.33 4.2093 21.33 5.3493V7.1693"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 20.7194V4.10938"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.06 20.7207H15.94"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="text-align-center" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 4.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.25999 9.5H16.74"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 14.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.25999 19.5H16.74"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="text-align-left" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 4.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 9.5H12.47"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 14.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 19.5H12.47"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="text-align-right" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 4.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.53 9.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 14.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.53 19.5H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="envelope" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="telegram" viewBox="0 0 26 26" fill="none">
      <path
        d="M13 2.16699C10.1268 2.16699 7.37128 3.30836 5.33964 5.34C3.30799 7.37165 2.16663 10.1271 2.16663 13.0003C2.16663 15.8735 3.30799 18.629 5.33964 20.6606C7.37128 22.6923 10.1268 23.8337 13 23.8337C15.8731 23.8337 18.6286 22.6923 20.6603 20.6606C22.6919 18.629 23.8333 15.8735 23.8333 13.0003C23.8333 10.1271 22.6919 7.37165 20.6603 5.34C18.6286 3.30836 15.8731 2.16699 13 2.16699V2.16699Z"
        fill="#29B6F6"
      />
      <path
        d="M18.3895 8.12468L16.3605 18.4846C16.3605 18.4846 16.2733 18.958 15.6861 18.958C15.3741 18.958 15.2132 18.8096 15.2132 18.8096L10.8181 15.1626L8.66771 14.0787L5.90792 13.3447C5.90792 13.3447 5.41663 13.2028 5.41663 12.7966C5.41663 12.458 5.922 12.2966 5.922 12.2966L17.4682 7.70976C17.4676 7.70922 17.8208 7.58247 18.0781 7.58301C18.2363 7.58301 18.4166 7.65072 18.4166 7.85384C18.4166 7.98926 18.3895 8.12468 18.3895 8.12468Z"
        fill="white"
      />
      <path
        d="M12.4583 16.5239L10.6025 18.3514C10.6025 18.3514 10.5218 18.4137 10.414 18.4164C10.3767 18.4175 10.3366 18.4116 10.2954 18.3932L10.8176 15.1621L12.4583 16.5239Z"
        fill="#B0BEC5"
      />
      <path
        d="M16.1942 9.85611C16.1026 9.73694 15.9336 9.71528 15.8145 9.80573L8.66663 14.0833C8.66663 14.0833 9.80738 17.2748 9.98125 17.8273C10.1557 18.3803 10.2954 18.3933 10.2954 18.3933L10.8176 15.1623L16.1433 10.2353C16.2624 10.1448 16.2846 9.97527 16.1942 9.85611Z"
        fill="#CFD8DC"
      />
    </symbol>
    <symbol id="pencil" viewBox="0 0 24 24" fill="none">
      <path
        d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8933 6.88916C12.3233 9.64916 14.5633 11.7592 17.3433 12.0392"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="arrow-up" viewBox="0 0 24 24" fill="none">
      <path
        d="M18.0701 9.57L12.0001 3.5L5.93005 9.57"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 20.4999V3.66992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </symbol>
    <symbol id="search" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
        stroke="currentColor"
        stroke-width="2"
      />
      <path
        d="M20.9209 22C20.6444 22 20.3679 21.8924 20.1682 21.6925L17.3111 18.8332C16.8963 18.4181 16.8963 17.7417 17.3111 17.3113C17.7258 16.8962 18.4017 16.8962 18.8318 17.3113L21.6889 20.1706C22.1037 20.5857 22.1037 21.2621 21.6889 21.6925C21.4739 21.8924 21.1974 22 20.9209 22Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="instagram" viewBox="0 0 19 19" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M-0.0149522 7.33871C-0.0518464 3.96666 -0.066846 2.59572 1.18739 1.29293C2.5037 -0.0719127 3.94118 -0.0599095 8.9749 -0.0178772C10.0172 -0.00917364 11.2137 0.000817495 12.5953 0.000138456C14.8239 0.00402366 14.9505 0.0223999 15.3728 0.0837137L15.397 0.0872218C17.3279 0.365097 18.7933 1.73706 18.9801 4.1176C19.0054 4.43585 19.0054 14.5621 18.9809 14.874C18.8051 17.1088 17.5195 18.3906 15.9393 18.7983C14.7558 19.1046 4.2551 19.1046 3.06998 18.7998C-0.192851 17.9566 -0.114606 14.7588 -0.0284389 11.2372C-0.0143783 10.6625 -0.000106743 10.0792 -0.000106743 9.49618C-0.000106743 8.69556 -0.00792645 7.98085 -0.0149522 7.33871ZM8.8048 2.48177C9.03447 2.48343 9.2659 2.4851 9.49828 2.4851H9.49511C9.77151 2.4851 10.0388 2.4833 10.2974 2.48155C12.5385 2.46642 14.1263 2.4557 15.3329 3.66231C16.5348 4.86352 16.5262 6.42528 16.5136 8.73975C16.5122 8.98486 16.5109 9.2384 16.5109 9.50085C16.5109 9.74358 16.5117 9.97732 16.5126 10.2026C16.5189 11.8939 16.5235 13.1107 16.1427 14.0957C15.1799 16.5661 12.7327 16.5438 10.2206 16.521C9.97945 16.5188 9.73774 16.5166 9.49669 16.5166C9.26579 16.5166 9.03556 16.5183 8.80684 16.52C6.20934 16.5389 3.80751 16.5564 2.85144 14.0957C2.47142 13.1174 2.47648 11.6626 2.48198 10.0795C2.48265 9.88827 2.48332 9.69519 2.48332 9.50085C2.48332 9.26162 2.48247 9.03078 2.48165 8.80788C2.47544 7.116 2.47091 5.88174 2.85144 4.90523C3.80978 2.44571 6.19343 2.46292 8.8048 2.48177ZM9.99769 3.74189C9.64404 3.74523 9.26844 3.74876 8.86969 3.74939V3.74781C4.19252 3.75256 3.74919 3.84123 3.74919 9.49769C3.74919 15.0892 3.9099 15.2491 9.49907 15.2491C9.78111 15.2491 10.0583 15.2522 10.3293 15.2552C13.0035 15.2845 15.0719 15.3072 15.2078 12.3334C15.6009 3.68912 14.962 3.69514 9.99769 3.74189ZM12.4013 5.75548C12.4013 5.29077 12.7782 4.91394 13.2429 4.91394C13.7076 4.91394 14.0844 5.29077 14.0844 5.75548C14.0844 6.22019 13.7076 6.59702 13.2429 6.59702C12.7782 6.59702 12.4013 6.22019 12.4013 5.75548ZM5.89619 9.50085C5.89619 7.5114 7.50882 5.89798 9.49828 5.89798C11.4877 5.89798 13.0996 7.5114 13.0996 9.50085C13.0996 11.4903 11.4877 13.1029 9.49828 13.1029C7.50882 13.1029 5.89619 11.4903 5.89619 9.50085ZM9.49828 7.16227C12.5897 7.16227 12.5937 11.8394 9.49828 11.8394C6.40761 11.8394 6.40286 7.16227 9.49828 7.16227Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="behance" viewBox="0 0 19 19" fill="none">
      <path
        d="M8.04105 8.56402C8.36991 8.05214 8.55769 7.44145 8.54684 6.78671C8.51774 5.03464 7.05964 3.6423 5.30728 3.6423H0.414944C0.185796 3.6423 0 3.8281 0 4.05725V14.8161C0 15.0452 0.185796 15.231 0.414944 15.231H5.87987C7.90822 15.231 9.58842 13.6053 9.59671 11.577C9.60181 10.3339 8.98536 9.23177 8.04105 8.56402ZM2.14629 5.7886H5.34905C5.92907 5.7886 6.401 6.26049 6.401 6.84054C6.401 7.42056 5.92911 7.89249 5.34905 7.89249H2.14629V5.7886ZM5.92754 13.0847H2.14629V10.0388H5.34905H5.92749C6.76724 10.0388 7.45046 10.722 7.45046 11.5617C7.45046 12.4015 6.76729 13.0847 5.92754 13.0847Z"
        fill="currentColor"
      />
      <path
        d="M18.9999 10.8141C18.9999 8.30886 17.0254 6.27078 14.5984 6.27078C12.1713 6.27078 10.1968 8.3089 10.1968 10.8141C10.1968 13.3192 12.1714 15.3574 14.5984 15.3574C16.071 15.3574 17.4395 14.6024 18.2589 13.3378C18.3611 13.1802 18.4538 13.0154 18.5362 12.8456C18.596 12.7224 18.5053 12.5789 18.3683 12.5786L16.2046 12.5732C16.1567 12.5731 16.1114 12.5927 16.077 12.626C15.6685 13.0233 15.1676 13.211 14.5984 13.211C13.5231 13.211 12.6217 12.4068 12.3973 11.3347H18.5691C18.807 11.3347 18.9999 11.1418 18.9999 10.904V10.8141ZM14.5984 8.41707C15.3859 8.41707 16.08 8.84863 16.4835 9.50064H12.7132C13.1167 8.84863 13.8109 8.41707 14.5984 8.41707Z"
        fill="currentColor"
      />
      <path
        d="M16.4275 5.73751H12.5236C12.3414 5.73751 12.1938 5.58985 12.1938 5.4077V4.42833C12.1938 4.24618 12.3414 4.09851 12.5236 4.09851H16.4275C16.6097 4.09851 16.7574 4.24618 16.7574 4.42833V5.4077C16.7574 5.58989 16.6097 5.73751 16.4275 5.73751Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="linkedin" viewBox="0 0 17 17" fill="none">
      <path
        d="M15.4622 0H1.53779C0.6885 0 0 0.6885 0 1.53779V15.4622C0 16.3115 0.6885 17 1.53779 17H15.4622C16.3115 17 17 16.3115 17 15.4622V1.53779C17 0.6885 16.3115 0 15.4622 0ZM5.26052 14.6789C5.26052 14.9261 5.06017 15.1264 4.813 15.1264H2.90802C2.66086 15.1264 2.46051 14.9261 2.46051 14.6789V6.69333C2.46051 6.44616 2.66086 6.24581 2.90802 6.24581H4.813C5.06017 6.24581 5.26052 6.44616 5.26052 6.69333V14.6789ZM3.86051 5.49305C2.86103 5.49305 2.05077 4.68279 2.05077 3.6833C2.05077 2.68382 2.86103 1.87356 3.86051 1.87356C4.86 1.87356 5.67026 2.68382 5.67026 3.6833C5.67026 4.68279 4.86004 5.49305 3.86051 5.49305ZM15.2159 14.715C15.2159 14.9422 15.0316 15.1264 14.8044 15.1264H12.7602C12.533 15.1264 12.3488 14.9422 12.3488 14.715V10.9693C12.3488 10.4105 12.5127 8.52069 10.8885 8.52069C9.62868 8.52069 9.37314 9.81421 9.32183 10.3947V14.715C9.32183 14.9422 9.13763 15.1264 8.91036 15.1264H6.93329C6.70606 15.1264 6.52181 14.9422 6.52181 14.715V6.65728C6.52181 6.43005 6.70606 6.24581 6.93329 6.24581H8.91036C9.13759 6.24581 9.32183 6.43005 9.32183 6.65728V7.35397C9.78897 6.65292 10.4832 6.11181 11.9614 6.11181C15.2346 6.11181 15.2159 9.16985 15.2159 10.8501V14.715Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="logo-malord" viewBox="0 0 59 13" fill="none">
      <path
        d="M16.3642 12.7142V12.7835H11.1709V12.7142C11.5891 12.4831 11.8593 12.2057 11.9812 11.8822C12.0974 11.5529 12.1555 11.0473 12.1555 10.3655V6.44821C12.1555 5.99755 12.0132 5.63644 11.7285 5.36488C11.4497 5.09333 11.0808 4.95755 10.6219 4.95755C10.2153 4.95755 9.89869 4.998 9.67213 5.07889C9.81736 5.45444 9.88997 5.91088 9.88997 6.44821V10.3655C9.88997 11.0473 9.94806 11.5529 10.0642 11.8822C10.1746 12.2057 10.4447 12.4831 10.8746 12.7142V12.7835H5.68129V12.7142C6.10535 12.4773 6.37257 12.2 6.48294 11.8822C6.59912 11.5529 6.65721 11.0473 6.65721 10.3655V6.44821C6.65721 6.02066 6.54103 5.66533 6.30867 5.38222C6.08212 5.09911 5.75681 4.95755 5.33274 4.95755C4.97258 4.95755 4.65889 4.99222 4.39167 5.06155V10.3655C4.39167 11.0473 4.44976 11.5529 4.56594 11.8822C4.68212 12.2057 4.95225 12.4831 5.37631 12.7142V12.7835H0.182986V12.7142C0.60705 12.4773 0.874268 12.2 0.98464 11.8822C1.10082 11.5586 1.16182 11.0531 1.16763 10.3655V6.80354C1.16763 6.01199 1.09501 5.46888 0.949786 5.17422C0.804559 4.87378 0.487963 4.61089 0 4.38556V4.31622C1.17924 4.21222 2.6199 3.94645 4.32196 3.51889H4.39167V4.88822C4.76345 4.46644 5.21656 4.13422 5.751 3.89156C6.28543 3.64312 6.83149 3.51889 7.38916 3.51889C8.53355 3.51889 9.28873 4.01 9.6547 4.99222C10.0207 4.54156 10.5115 4.18333 11.1273 3.91756C11.7431 3.65178 12.353 3.51889 12.9572 3.51889C13.631 3.51889 14.2061 3.75 14.6825 4.21222C15.153 4.66867 15.3883 5.414 15.3883 6.44821V10.3655C15.3883 11.0473 15.4464 11.5529 15.5625 11.8822C15.6729 12.2 15.9401 12.4773 16.3642 12.7142Z"
        fill="currentColor"
      />
      <path
        d="M23.3612 13.0002C22.3911 13.0002 21.8131 12.5437 21.6272 11.6309C20.8779 12.5437 20.0326 13.0002 19.0916 13.0002C18.4003 13.0002 17.8165 12.8124 17.3401 12.4369C16.8638 12.0613 16.6285 11.5384 16.6343 10.8682C16.6343 9.00776 18.2928 7.87821 21.6098 7.47954V6.30088C21.6098 5.63644 21.421 5.12511 21.0434 4.76689C20.6716 4.40867 20.1575 4.22956 19.5011 4.22956C19.1874 4.22956 18.8389 4.28733 18.4555 4.40289C18.9086 4.48956 19.2571 4.67156 19.5011 4.94889C19.7451 5.232 19.8642 5.55555 19.8584 5.91955C19.8584 6.30666 19.7073 6.63599 19.4053 6.90754C19.109 7.1791 18.7663 7.31488 18.3771 7.31488C17.9646 7.31488 17.619 7.18488 17.3401 6.92488C17.0613 6.6591 16.9219 6.3211 16.9219 5.91088C16.9219 5.20022 17.3082 4.62533 18.0808 4.18622C18.8476 3.75289 19.8497 3.53045 21.087 3.51889C21.6505 3.51889 22.1501 3.57089 22.5857 3.67489C23.0214 3.77311 23.4135 3.93778 23.7621 4.16889C24.1106 4.39422 24.3778 4.712 24.5637 5.12222C24.7496 5.53244 24.8426 6.02644 24.8426 6.60421V10.2615C24.8484 10.5677 24.8629 10.8017 24.8861 10.9635C24.9094 11.1195 24.9587 11.2726 25.0343 11.4229C25.1156 11.5731 25.2376 11.6857 25.4002 11.7609C25.5687 11.836 25.7924 11.8937 26.0712 11.9342V12.0035C25.711 12.2866 25.2753 12.5235 24.7641 12.7142C24.2588 12.9048 23.7911 13.0002 23.3612 13.0002ZM21.0957 7.90421C20.7646 7.90421 20.4712 8.08332 20.2156 8.44154C19.96 8.80554 19.8351 9.26487 19.8409 9.81953C19.8409 10.3915 19.9571 10.822 20.1895 11.1109C20.4277 11.4055 20.6716 11.5529 20.9214 11.5529C21.1886 11.5529 21.4181 11.5066 21.6098 11.4142V7.99087C21.3833 7.93309 21.2119 7.90421 21.0957 7.90421Z"
        fill="currentColor"
      />
      <path
        d="M31.2558 12.7142V12.7835H25.9928V12.7142C26.4168 12.4773 26.684 12.2 26.7944 11.8822C26.9106 11.5529 26.9687 11.0473 26.9687 10.3655V3.28489C26.9687 2.51068 26.899 1.97046 26.7596 1.66424C26.6143 1.36379 26.2977 1.10091 25.8098 0.875573V0.80624C27.082 0.690685 28.5459 0.42202 30.2014 0.000244141H30.2712V10.3655C30.2712 11.0473 30.3292 11.5529 30.4454 11.8822C30.5616 12.2057 30.8317 12.4831 31.2558 12.7142Z"
        fill="currentColor"
      />
      <path
        d="M39.5686 4.82755C40.4981 5.69422 40.9628 6.82666 40.9628 8.22487C40.9628 9.61731 40.5097 10.7584 39.6035 11.6482C38.6972 12.538 37.5441 12.9886 36.1441 13.0002C34.7442 13.0002 33.5881 12.5524 32.6761 11.6569C31.7699 10.7555 31.3197 9.61153 31.3255 8.22487C31.3255 6.82666 31.7902 5.69133 32.7197 4.81889C33.6491 3.94645 34.7906 3.51023 36.1441 3.51023C37.4919 3.51023 38.6333 3.94934 39.5686 4.82755ZM36.1441 12.4455C36.7541 12.4455 37.1462 12.0353 37.3205 11.2149C37.4889 10.3771 37.5732 9.39198 37.5732 8.25954C37.5732 5.47466 37.0968 4.07645 36.1441 4.06489C35.1915 4.06489 34.7151 5.46311 34.7151 8.25954C34.7151 10.3511 34.9417 11.6366 35.3948 12.1162C35.5981 12.3357 35.8479 12.4455 36.1441 12.4455Z"
        fill="currentColor"
      />
      <path
        d="M48.3781 3.98689C48.6918 4.29311 48.8486 4.66867 48.8486 5.11355C48.8486 5.55844 48.6918 5.9311 48.3781 6.23155C48.0702 6.52621 47.6926 6.67355 47.2453 6.67355C46.798 6.67355 46.4262 6.52621 46.13 6.23155C45.8337 5.93688 45.6856 5.56711 45.6856 5.12222C45.6856 4.67733 45.8337 4.29889 46.13 3.98689C46.4262 3.67489 46.798 3.51889 47.2453 3.51889C47.6868 3.51889 48.0644 3.67489 48.3781 3.98689ZM46.6528 12.7142V12.7835H41.1719V12.7142C41.596 12.4773 41.8632 12.2 41.9736 11.8822C42.0897 11.5586 42.1507 11.0531 42.1566 10.3655V6.80354C42.1566 6.01199 42.0839 5.46888 41.9387 5.17422C41.7935 4.87378 41.4769 4.61089 40.9889 4.38556V4.31622C42.1682 4.21222 43.6088 3.94645 45.3109 3.51889H45.3806V10.3655C45.3806 11.0473 45.4561 11.5471 45.6071 11.8649C45.7582 12.1826 46.1067 12.4657 46.6528 12.7142Z"
        fill="currentColor"
      />
      <path
        d="M53.5975 3.99556C53.0457 3.99556 52.6071 4.36822 52.2818 5.11355C51.9565 5.86466 51.7938 6.78621 51.7938 7.87821C51.7938 8.1382 51.8054 8.39243 51.8287 8.64087C51.8519 8.88931 51.8897 9.16087 51.942 9.45553C51.9942 9.74442 52.0727 10.0102 52.1772 10.2529C52.2876 10.4897 52.4183 10.7093 52.5693 10.9115C52.7204 11.1137 52.915 11.2726 53.1532 11.3882C53.3913 11.5037 53.6585 11.5615 53.9548 11.5615C54.1814 11.55 54.3992 11.4951 54.6083 11.3969V4.60222C54.3585 4.19778 54.0216 3.99556 53.5975 3.99556ZM54.6868 13.0002H54.6083V11.5962C53.8473 12.5322 52.9789 13.0002 52.003 13.0002C51.027 13.006 50.2079 12.6102 49.5457 11.8129C48.8835 11.0097 48.5553 9.92353 48.5611 8.5542C48.5727 7.17332 49.0055 5.99177 49.8594 5.00955C50.7191 4.01578 51.8752 3.51889 53.3274 3.51889C53.6585 3.51889 54.0855 3.55356 54.6083 3.62289V3.28489C54.6083 2.51068 54.5386 1.97046 54.3992 1.66424C54.254 1.36379 53.9374 1.10091 53.4494 0.875573V0.80624C54.6461 0.702241 56.0867 0.433575 57.7714 0.000244141H57.8411V9.71553C57.8411 10.4897 57.9108 11.03 58.0502 11.3362C58.1896 11.6366 58.5062 11.8995 59 12.1249V12.1942C57.7975 12.2982 56.3598 12.5668 54.6868 13.0002Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="social-inst" viewBox="0 0 18 18" fill="none">
      <path
        d="M5 0C2.243 0 0 2.243 0 5V13C0 15.757 2.243 18 5 18H13C15.757 18 18 15.757 18 13V5C18 2.243 15.757 0 13 0H5ZM5 2H13C14.654 2 16 3.346 16 5V13C16 14.654 14.654 16 13 16H5C3.346 16 2 14.654 2 13V5C2 3.346 3.346 2 5 2ZM14 3C13.7348 3 13.4804 3.10536 13.2929 3.29289C13.1054 3.48043 13 3.73478 13 4C13 4.26522 13.1054 4.51957 13.2929 4.70711C13.4804 4.89464 13.7348 5 14 5C14.2652 5 14.5196 4.89464 14.7071 4.70711C14.8946 4.51957 15 4.26522 15 4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3ZM9 4C6.243 4 4 6.243 4 9C4 11.757 6.243 14 9 14C11.757 14 14 11.757 14 9C14 6.243 11.757 4 9 4ZM9 6C10.654 6 12 7.346 12 9C12 10.654 10.654 12 9 12C7.346 12 6 10.654 6 9C6 7.346 7.346 6 9 6Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="social-messenger" viewBox="0 0 20 21" fill="none">
      <path
        d="M9.9999 0.398438C4.6983 0.398438 0.399902 4.51764 0.399902 9.59844C0.399902 12.3194 1.64044 14.7562 3.5999 16.4406V20.3984L7.46865 18.4641C8.27632 18.6755 9.12231 18.7984 9.9999 18.7984C15.3015 18.7984 19.5999 14.6792 19.5999 9.59844C19.5999 4.51764 15.3015 0.398438 9.9999 0.398438ZM9.08896 7.08438L11.4499 9.44844L15.6671 7.08438L10.9108 12.2391L8.60459 9.76094L4.27646 12.1828L9.08896 7.08438Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="social-tg" viewBox="0 0 18 16" fill="none">
      <path
        d="M17.6601 0.219953C17.3531 -0.0344475 16.8708 -0.0708476 16.3722 0.124753H16.3713C15.8469 0.330354 1.52653 6.33197 0.943561 6.57717C0.837529 6.61317 -0.088506 6.95077 0.00688135 7.70278C0.092034 8.38078 0.836301 8.66158 0.927185 8.69398L4.56787 9.91198C4.80941 10.6976 5.69983 13.596 5.89674 14.2152C6.01956 14.6012 6.21975 15.1084 6.5706 15.2128C6.87846 15.3288 7.18468 15.2228 7.38282 15.0708L9.60866 13.0536L13.2019 15.7916L13.2874 15.8416C13.5314 15.9472 13.7652 16 13.9883 16C14.1606 16 14.326 15.9684 14.4841 15.9052C15.0224 15.6892 15.2377 15.188 15.2603 15.1312L17.9442 1.50036C18.108 0.772355 17.8803 0.401954 17.6601 0.219953ZM7.7787 10.3992L6.55054 13.5992L5.32237 9.59918L14.7383 2.79916L7.7787 10.3992Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="social-twitter" viewBox="0 0 22 18" fill="none">
      <path
        d="M21.3999 2.54767C20.6343 2.88768 19.8119 3.11648 18.9487 3.21968C19.8303 2.69168 20.5063 1.85568 20.8247 0.858875C20.0007 1.34768 19.0871 1.70288 18.1143 1.89487C17.3359 1.06528 16.2271 0.546875 14.9999 0.546875C12.6431 0.546875 10.7327 2.45808 10.7327 4.81408C10.7327 5.14848 10.7711 5.47487 10.8431 5.78608C7.29672 5.60847 4.15272 3.90927 2.04712 1.32687C1.68072 1.95727 1.47032 2.69008 1.47032 3.47327C1.47032 4.95328 2.22312 6.25968 3.36792 7.02448C2.66872 7.00208 2.01032 6.81008 1.43512 6.49088C1.43512 6.50928 1.43512 6.52607 1.43512 6.54448C1.43512 8.61248 2.90552 10.3373 4.85832 10.7285C4.50072 10.8261 4.12312 10.8781 3.73352 10.8781C3.45912 10.8781 3.19112 10.8509 2.93112 10.8021C3.47432 12.4973 5.05032 13.7317 6.91752 13.7661C5.45752 14.9109 3.61752 15.5933 1.61752 15.5933C1.27352 15.5933 0.933521 15.5733 0.599121 15.5333C2.48792 16.7437 4.73032 17.4501 7.14072 17.4501C14.9903 17.4501 19.2815 10.9477 19.2815 5.30848C19.2815 5.12367 19.2775 4.93968 19.2695 4.75647C20.1039 4.15408 20.8279 3.40287 21.3999 2.54767Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="social-whatsup" viewBox="0 0 20 20" fill="none">
      <path
        d="M9.9999 0.398438C4.6983 0.398438 0.399902 4.69684 0.399902 9.99844C0.399902 11.7994 0.905776 13.4785 1.76865 14.9187L0.48584 19.5984L5.26553 18.3438C6.66339 19.1385 8.27709 19.5984 9.9999 19.5984C15.3015 19.5984 19.5999 15.3 19.5999 9.99844C19.5999 4.69684 15.3015 0.398438 9.9999 0.398438ZM6.71396 5.52031C6.86997 5.52031 7.03025 5.51936 7.16865 5.52656C7.33985 5.53056 7.52619 5.5431 7.70459 5.9375C7.91659 6.4063 8.3782 7.58236 8.4374 7.70156C8.4966 7.82076 8.53855 7.96119 8.45615 8.11719C8.37775 8.27719 8.33698 8.37403 8.22178 8.51562C8.10258 8.65322 7.97196 8.82413 7.86397 8.92813C7.74476 9.04733 7.62168 9.17803 7.75928 9.41563C7.89688 9.65322 8.37475 10.4321 9.08115 11.0609C9.98915 11.8721 10.7553 12.1214 10.9937 12.2406C11.2321 12.3598 11.3701 12.3413 11.5077 12.1813C11.6493 12.0253 12.1024 11.49 12.2624 11.2516C12.4184 11.0132 12.5777 11.0544 12.7937 11.1328C13.0129 11.2112 14.1818 11.7871 14.4202 11.9062C14.6586 12.0254 14.8149 12.0844 14.8749 12.1813C14.9365 12.2812 14.9366 12.7573 14.739 13.3125C14.5414 13.8669 13.571 14.403 13.1358 14.4406C12.6966 14.4814 12.2868 14.638 10.2812 13.8484C7.86195 12.8956 6.33629 10.4178 6.21709 10.2578C6.09789 10.1018 5.24834 8.96956 5.24834 7.80156C5.24834 6.62956 5.86283 6.05559 6.07803 5.81719C6.29723 5.57879 6.55397 5.52031 6.71396 5.52031Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="lock-close" viewBox="0 0 41 41" fill="none">
      <path
        d="M10.2502 37.5859C9.31058 37.5859 8.50624 37.2514 7.83714 36.5823C7.16804 35.9132 6.8335 35.1089 6.8335 34.1693V17.0859C6.8335 16.1464 7.16804 15.342 7.83714 14.6729C8.50624 14.0038 9.31058 13.6693 10.2502 13.6693H11.9585V10.2526C11.9585 7.88941 12.7913 5.875 14.4569 4.20937C16.1226 2.54375 18.137 1.71094 20.5002 1.71094C22.8634 1.71094 24.8778 2.54375 26.5434 4.20937C28.209 5.875 29.0418 7.88941 29.0418 10.2526V13.6693H30.7502C31.6897 13.6693 32.4941 14.0038 33.1632 14.6729C33.8323 15.342 34.1668 16.1464 34.1668 17.0859V34.1693C34.1668 35.1089 33.8323 35.9132 33.1632 36.5823C32.4941 37.2514 31.6897 37.5859 30.7502 37.5859H10.2502ZM20.5002 29.0443C21.4397 29.0443 22.2441 28.7097 22.9132 28.0406C23.5823 27.3715 23.9168 26.5672 23.9168 25.6276C23.9168 24.688 23.5823 23.8837 22.9132 23.2146C22.2441 22.5455 21.4397 22.2109 20.5002 22.2109C19.5606 22.2109 18.7562 22.5455 18.0871 23.2146C17.418 23.8837 17.0835 24.688 17.0835 25.6276C17.0835 26.5672 17.418 27.3715 18.0871 28.0406C18.7562 28.7097 19.5606 29.0443 20.5002 29.0443ZM15.3752 13.6693H25.6252V10.2526C25.6252 8.82899 25.1269 7.61892 24.1304 6.6224C23.1338 5.62587 21.9238 5.1276 20.5002 5.1276C19.0766 5.1276 17.8665 5.62587 16.87 6.6224C15.8734 7.61892 15.3752 8.82899 15.3752 10.2526V13.6693Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="lock-open" viewBox="0 0 41 41" fill="none">
      <path
        d="M10.2502 13.6693H25.6252V10.2526C25.6252 8.82899 25.1269 7.61892 24.1304 6.6224C23.1338 5.62587 21.9238 5.1276 20.5002 5.1276C19.0766 5.1276 17.8665 5.62587 16.87 6.6224C15.8734 7.61892 15.3752 8.82899 15.3752 10.2526H11.9585C11.9585 7.88941 12.7913 5.875 14.4569 4.20937C16.1226 2.54375 18.137 1.71094 20.5002 1.71094C22.8634 1.71094 24.8778 2.54375 26.5434 4.20937C28.209 5.875 29.0418 7.88941 29.0418 10.2526V13.6693H30.7502C31.6897 13.6693 32.4941 14.0038 33.1632 14.6729C33.8323 15.342 34.1668 16.1464 34.1668 17.0859V34.1693C34.1668 35.1089 33.8323 35.9132 33.1632 36.5823C32.4941 37.2514 31.6897 37.5859 30.7502 37.5859H10.2502C9.31058 37.5859 8.50624 37.2514 7.83714 36.5823C7.16804 35.9132 6.8335 35.1089 6.8335 34.1693V17.0859C6.8335 16.1464 7.16804 15.342 7.83714 14.6729C8.50624 14.0038 9.31058 13.6693 10.2502 13.6693ZM20.5002 29.0443C21.4397 29.0443 22.2441 28.7097 22.9132 28.0406C23.5823 27.3715 23.9168 26.5672 23.9168 25.6276C23.9168 24.688 23.5823 23.8837 22.9132 23.2146C22.2441 22.5455 21.4397 22.2109 20.5002 22.2109C19.5606 22.2109 18.7562 22.5455 18.0871 23.2146C17.418 23.8837 17.0835 24.688 17.0835 25.6276C17.0835 26.5672 17.418 27.3715 18.0871 28.0406C18.7562 28.7097 19.5606 29.0443 20.5002 29.0443Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="eye-open" viewBox="0 0 25 25" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.20513 12.5C6.66296 14.7936 8.9567 16.9 12.5 16.9C16.0433 16.9 18.3371 14.7936 19.7949 12.5C18.3371 10.2064 16.0433 8.1 12.5 8.1C8.9567 8.1 6.66296 10.2064 5.20513 12.5ZM3.98551 12.1913C5.53974 9.60093 8.20179 6.9 12.5 6.9C16.7982 6.9 19.4603 9.60093 21.0145 12.1913L21.1997 12.5L21.0145 12.8087C19.4603 15.3991 16.7982 18.1 12.5 18.1C8.20179 18.1 5.53974 15.3991 3.98551 12.8087L3.80029 12.5L3.98551 12.1913ZM12.5 9.4C10.7879 9.4 9.4 10.7879 9.4 12.5C9.4 14.2121 10.7879 15.6 12.5 15.6C14.2121 15.6 15.6 14.2121 15.6 12.5C15.6 10.7879 14.2121 9.4 12.5 9.4Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="eye-close" viewBox="0 0 25 25" fill="none">
      <path
        d="M7 15.5L5.5 17.5M20.5 12.5C19.8612 13.5647 19.041 14.6294 18.0008 15.501M18.0008 15.501C16.5985 16.676 14.7965 17.5 12.5 17.5M18.0008 15.501L18 15.5M18.0008 15.501L19.5 17.5M12.5 17.5C8.5 17.5 6 15 4.5 12.5M12.5 17.5V20M15.5 17L16.5 19.5M9.5 17L8.5 19.5"
        stroke="currentColor"
        stroke-width="1.2"
      />
      />
    </symbol>
    <symbol id="close" width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M4.79976 14.7344L3.74976 13.6844L7.94976 9.48438L3.74976 5.28438L4.79976 4.23438L8.99976 8.43438L13.1998 4.23438L14.2498 5.28438L10.0498 9.48438L14.2498 13.6844L13.1998 14.7344L8.99976 10.5344L4.79976 14.7344Z"
        fill="#1C1B1F"
      />
    </symbol>
    <symbol id="galery" viewBox="0 0 35 35" fill="none">
      <g>
        <path
          d="M6.28174 28.4374C5.54508 28.4374 4.92155 28.1822 4.41113 27.6718C3.90072 27.1614 3.64551 26.5379 3.64551 25.8012V9.19873C3.64551 8.46208 3.90072 7.83854 4.41113 7.32813C4.92155 6.81771 5.54508 6.5625 6.28174 6.5625H28.7175C29.4542 6.5625 30.0777 6.81771 30.5881 7.32813C31.0986 7.83854 31.3538 8.46208 31.3538 9.19873V25.8012C31.3538 26.5379 31.0986 27.1614 30.5881 27.6718C30.0777 28.1822 29.4542 28.4374 28.7175 28.4374H6.28174ZM6.28174 26.25H28.7175C28.8297 26.25 28.9326 26.2032 29.0261 26.1097C29.1196 26.0162 29.1663 25.9134 29.1663 25.8012V9.19873C29.1663 9.08654 29.1196 8.98369 29.0261 8.89018C28.9326 8.7967 28.8297 8.74996 28.7175 8.74996H6.28174C6.16954 8.74996 6.06669 8.7967 5.97319 8.89018C5.87971 8.98369 5.83297 9.08654 5.83297 9.19873V25.8012C5.83297 25.9134 5.87971 26.0162 5.97319 26.1097C6.06669 26.2032 6.16954 26.25 6.28174 26.25ZM9.84346 23.3333H25.268L20.4724 16.9391L16.3779 22.2676L13.4612 18.5377L9.84346 23.3333Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="starInCircle" viewBox="0 0 25 25" fill="none">
      <circle cx="12.5" cy="12.5" r="12.5" fill="#C4C4C4" />
      <circle cx="12.5" cy="12.5" r="12.5" fill="#575757" />
      <path
        d="M11.3859 7.51558C11.8349 6.13361 13.7901 6.13361 14.2391 7.51558L14.6507 8.78242C14.8515 9.40046 15.4275 9.8189 16.0773 9.8189H17.4093C18.8624 9.8189 19.4666 11.6783 18.291 12.5324L17.2134 13.3154C16.6876 13.6973 16.4677 14.3744 16.6685 14.9924L17.0801 16.2593C17.5291 17.6412 15.9474 18.7904 14.7718 17.9363L13.6942 17.1534C13.1684 16.7714 12.4566 16.7714 11.9308 17.1534L10.8532 17.9363C9.67761 18.7904 8.09589 17.6412 8.54491 16.2593L8.95654 14.9924C9.15735 14.3744 8.93736 13.6973 8.41163 13.3154L7.33399 12.5324C6.15842 11.6783 6.76258 9.8189 8.21566 9.8189H9.54771C10.1975 9.8189 10.7735 9.40046 10.9743 8.78242L11.3859 7.51558Z"
        fill="white"
      />
    </symbol>
    <symbol id="email" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="undo" viewBox="0 0 20 20" fill="none">
      <g>
        <path
          d="M15.8333 15.8307V12.4974C15.8333 11.803 15.5903 11.2127 15.1042 10.7266C14.6181 10.2405 14.0278 9.9974 13.3333 9.9974H5.6875L8.6875 12.9974L7.5 14.1641L2.5 9.16406L7.5 4.16406L8.6875 5.33073L5.6875 8.33073H13.3333C14.4861 8.33073 15.4688 8.73698 16.2812 9.54948C17.0938 10.362 17.5 11.3446 17.5 12.4974V15.8307H15.8333Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="redo" viewBox="0 0 20 20" fill="none">
      <g>
        <path
          d="M4.16667 15.8307V12.4974C4.16667 11.803 4.40972 11.2127 4.89583 10.7266C5.38194 10.2405 5.97222 9.9974 6.66667 9.9974H14.3125L11.3125 12.9974L12.5 14.1641L17.5 9.16406L12.5 4.16406L11.3125 5.33073L14.3125 8.33073H6.66667C5.51389 8.33073 4.53125 8.73698 3.71875 9.54948C2.90625 10.362 2.5 11.3446 2.5 12.4974V15.8307H4.16667Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="download" viewBox="0 0 15 15" fill="none">
      <mask
        id="mask0_618_16"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_618_16)">
        <path
          d="M7.5 10L4.375 6.875L5.25 5.96875L6.875 7.59375V2.5H8.125V7.59375L9.75 5.96875L10.625 6.875L7.5 10ZM3.75 12.5C3.40625 12.5 3.11198 12.3776 2.86719 12.1328C2.6224 11.888 2.5 11.5938 2.5 11.25V9.375H3.75V11.25H11.25V9.375H12.5V11.25C12.5 11.5938 12.3776 11.888 12.1328 12.1328C11.888 12.3776 11.5938 12.5 11.25 12.5H3.75Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="face" viewBox="0 0 15 15" fill="none">
      <mask
        id="mask0_4850_2521"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="15"
      >
        <rect width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4850_2521)">
        <path
          d="M7.5 12.5C6.10417 12.5 4.92188 12.0156 3.95312 11.0469C2.98438 10.0781 2.5 8.89583 2.5 7.5C2.5 6.10417 2.98438 4.92188 3.95312 3.95312C4.92188 2.98438 6.10417 2.5 7.5 2.5C8.89583 2.5 10.0781 2.98438 11.0469 3.95312C12.0156 4.92188 12.5 6.10417 12.5 7.5C12.5 8.89583 12.0156 10.0781 11.0469 11.0469C10.0781 12.0156 8.89583 12.5 7.5 12.5ZM7.5 11.25C8.54167 11.25 9.42708 10.8854 10.1562 10.1562C10.8854 9.42708 11.25 8.54167 11.25 7.5C11.25 7.32292 11.237 7.14844 11.2109 6.97656C11.1849 6.80469 11.1458 6.63542 11.0937 6.46875C10.9375 6.5 10.7812 6.52344 10.625 6.53906C10.4687 6.55469 10.3125 6.5625 10.1562 6.5625C9.5 6.5625 8.875 6.4375 8.28125 6.1875C7.6875 5.9375 7.15625 5.57292 6.6875 5.09375C6.39583 5.6875 5.99479 6.20312 5.48437 6.64062C4.97396 7.07812 4.39583 7.39583 3.75 7.59375C3.78125 8.61458 4.15885 9.47917 4.88281 10.1875C5.60677 10.8958 6.47917 11.25 7.5 11.25ZM4 6.15625C4.45833 5.91667 4.80729 5.63802 5.04687 5.32031C5.28646 5.0026 5.52083 4.625 5.75 4.1875C5.35417 4.39583 5.00521 4.66927 4.70312 5.00781C4.40104 5.34635 4.16667 5.72917 4 6.15625ZM5.9375 8.75C5.76042 8.75 5.61198 8.6901 5.49219 8.57031C5.3724 8.45052 5.3125 8.30208 5.3125 8.125C5.3125 7.94792 5.3724 7.79948 5.49219 7.67969C5.61198 7.5599 5.76042 7.5 5.9375 7.5C6.11458 7.5 6.26302 7.5599 6.38281 7.67969C6.5026 7.79948 6.5625 7.94792 6.5625 8.125C6.5625 8.30208 6.5026 8.45052 6.38281 8.57031C6.26302 8.6901 6.11458 8.75 5.9375 8.75ZM10.1562 5.3125H10.3437C10.4062 5.3125 10.4687 5.30729 10.5312 5.29687C10.1875 4.82812 9.7526 4.45312 9.22656 4.17187C8.70052 3.89062 8.125 3.75 7.5 3.75H7.3125C7.25 3.75 7.19271 3.75521 7.14062 3.76562C7.54687 4.23437 7.97656 4.60937 8.42969 4.89062C8.88281 5.17187 9.45833 5.3125 10.1562 5.3125ZM9.0625 8.75C8.88542 8.75 8.73698 8.6901 8.61719 8.57031C8.4974 8.45052 8.4375 8.30208 8.4375 8.125C8.4375 7.94792 8.4974 7.79948 8.61719 7.67969C8.73698 7.5599 8.88542 7.5 9.0625 7.5C9.23958 7.5 9.38802 7.5599 9.50781 7.67969C9.6276 7.79948 9.6875 7.94792 9.6875 8.125C9.6875 8.30208 9.6276 8.45052 9.50781 8.57031C9.38802 8.6901 9.23958 8.75 9.0625 8.75ZM0.625 3.75V1.875C0.625 1.53125 0.747396 1.23698 0.992188 0.992188C1.23698 0.747396 1.53125 0.625 1.875 0.625H3.75V1.875H1.875V3.75H0.625ZM3.75 14.375H1.875C1.53125 14.375 1.23698 14.2526 0.992188 14.0078C0.747396 13.763 0.625 13.4687 0.625 13.125V11.25H1.875V13.125H3.75V14.375ZM11.25 14.375V13.125H13.125V11.25H14.375V13.125C14.375 13.4687 14.2526 13.763 14.0078 14.0078C13.763 14.2526 13.4687 14.375 13.125 14.375H11.25ZM13.125 3.75V1.875H11.25V0.625H13.125C13.4687 0.625 13.763 0.747396 14.0078 0.992188C14.2526 1.23698 14.375 1.53125 14.375 1.875V3.75H13.125Z"
          fill="white"
        />
      </g>
    </symbol>
  </svg>
</template>

<script>
export default {
  name: 'SvgSprite',
};
</script>
